module.exports = __webpack_public_path__ + "img/Weapon_140.4d393ece.png";